import { getAsyncData } from "../utils/storeAndRetrieveUtil";

import { get } from "./apiService";
import { getPortfolioEstimateAssets } from "./digitalWalletService";

export const getUser = async () => {
  try {
    const authId = await getAsyncData("authId");
    if (authId === null) {
      throw new Error("Could not get user id");
    }
    const result = await get("/api/v1/user/get-user");
    return result;
  } catch (error) {
    throw new Error(`Could not get balance. Error: ${error.message}`);
  }
};

export const getUserBalances = async () => {
  try {
    const result = await getPortfolioEstimateAssets();

    if (result) {
      return result;
    }

    return null;
  } catch (error) {
    throw new Error(`Could not get balances. Error: ${error.message}`);
  }
};
